import React from 'react';
import { FallbackProps } from 'react-error-boundary';
import { IoWarning, IoRefresh, IoArrowBack } from 'react-icons/io5';

const ErrorFallback: React.FC<FallbackProps> = ({ error, resetErrorBoundary }) => {
  const WarningIcon = IoWarning as React.ComponentType<{ className?: string }>;
  const RefreshIcon = IoRefresh as React.ComponentType<{ className?: string }>;
  const ArrowBackIcon = IoArrowBack as React.ComponentType<{ className?: string }>;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8 text-center">
        <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
          <WarningIcon className="text-red-600 text-3xl" />
        </div>
        
        <h1 className="text-2xl font-bold text-gray-900 mb-2">
          Something went wrong
        </h1>
        
        <p className="text-gray-600 mb-8">
          We're sorry, but something unexpected happened. Please try refreshing the page.
        </p>
        
        <div className="space-y-3">
          <button
            onClick={() => window.location.reload()}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-2 px-4 rounded-lg flex items-center justify-center space-x-2 transition-colors"
          >
            <RefreshIcon className="text-lg" />
            <span>Refresh Page</span>
          </button>
          
          <button
            onClick={resetErrorBoundary}
            className="w-full bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium py-2 px-4 rounded-lg flex items-center justify-center space-x-2 transition-colors"
          >
            <ArrowBackIcon className="text-lg" />
            <span>Try Again</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorFallback; 